import * as Vue from 'vue'
const allVue = Vue
const gh = allVue.h
import KendoDataSourceMixin from './KendoDataSourceMixin'

export default {
    name: 'kendo-datasource',
    mixins: [ KendoDataSourceMixin ],
    setup() {
        const v3 = !!gh
        return {
            v3
        }
    },
    render (createElement) {
        const h = gh || createElement
        return h('div')
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoDataSource/index.js